import { create } from 'zustand'
import { getUserOrgStatusV1 } from '../utility/userOrgStatus'

let inFlightLoad = null
let inFlightUserId = null

const INITIAL_STATE = {
  userId: null,
  userOrgStatus: null,
  isLoading: false,
  error: null,
}

export const useActiveUserOrgStore = create((set, get) => ({
  ...INITIAL_STATE,

  resetActiveUserOrgStore: () => {
    inFlightLoad = null
    inFlightUserId = null
    set({ ...INITIAL_STATE })
  },

  loadUserOrgStatus: async ({ session = null, userId = null, forceRefresh = false }) => {
    if (!session || !userId) return null

    const state = get()
    if (!forceRefresh && state.userId === userId && state.userOrgStatus !== null) {
      return state.userOrgStatus
    }

    if (!forceRefresh && inFlightLoad && inFlightUserId === userId) {
      return inFlightLoad
    }

    set({
      userId,
      isLoading: true,
      error: null,
      ...(state.userId !== userId ? { userOrgStatus: null } : {}),
    })

    inFlightUserId = userId
    inFlightLoad = getUserOrgStatusV1(session)
      .then((userOrgStatus) => {
        inFlightLoad = null
        inFlightUserId = null
        const resolvedUserId = userOrgStatus?.user_id || userId
        const normalizedUserOrgStatus = userOrgStatus ?? {
          user_id: resolvedUserId,
          active_org_ids: [],
          by_status: { active: [], suspended: [] },
        }
        set({
          userId: resolvedUserId,
          userOrgStatus: normalizedUserOrgStatus,
          isLoading: false,
          error: null,
        })
        return normalizedUserOrgStatus
      })
      .catch((error) => {
        inFlightLoad = null
        inFlightUserId = null
        set({
          userId,
          userOrgStatus: {
            user_id: userId,
            active_org_ids: [],
            by_status: { active: [], suspended: [] },
          },
          isLoading: false,
          error,
        })
        return null
      })

    return inFlightLoad
  },
}))

export const loadUserOrgStatus = (params) =>
  useActiveUserOrgStore.getState().loadUserOrgStatus(params)

export const resetActiveUserOrgStore = () => {
  useActiveUserOrgStore.getState().resetActiveUserOrgStore()
}

export const getCachedUserOrgStatus = (userId) => {
  const { userId: cachedUserId, userOrgStatus } = useActiveUserOrgStore.getState()
  if (!userId || cachedUserId !== userId || userOrgStatus === null) return null
  return userOrgStatus
}
